// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import SuccessBannerClient from "./SuccessBannerClient-APP_CLIENT";

export interface BannerClientProps {
  title: string;
  description: string;
  buttonText: string;
  isButtonVisible: boolean;
  onClick: () => void;
}

export interface DefaultSuccessBannerProps {
  direction: "ltr" | "rtl";
}

export default SuccessBannerClient;
